import React, { useState, useEffect, SetStateAction } from 'react'
import { FilterValueDto } from '../Business/Common/CommonBusiness';
import { delayClose, lowerFirstLetter, toggleStateString } from '../Hook/Common'
import { rtnUrlStatusBooleanImg } from '../Hook/CommonRenderGrid/GridRender';
interface Props {
    filterData?: FilterValueDto[],
    property: string,
    overrideProperty: string
    count: string[],
    FiltriAttivi: boolean[] | undefined
    isVisibleFiltriString: string,
    actionFilters: {
        checkFilter: (value: string) => boolean,
        resetFilter: (value: string) => void,
        settingVisibility: (value: SetStateAction<string>) => void,
        closeAll(): any,
        updateCount(property: string): string[],
        getFiltriAttivi(id: boolean, checked: boolean, property: string): any,
        orderBy(property: string, isAscending: boolean): any,
        getFilters(property: string, text: string): any,
    }
}

const FilterMenuIconBooleanCheckbox: React.FC<Props> = (props) => {
    const [data, setData] = useState<FilterValueDto[] | undefined>([])
    const [searchText, setSearchText] = useState<string>("")
    const [showList, setShowList] = useState<boolean>(false)
    const [showListFixed, setShowListFixed] = useState<boolean>(false)

    const visibilityAction = () => props.actionFilters.settingVisibility(toggleStateString(props.property, props.isVisibleFiltriString));

    useEffect(() => {
        if (props.filterData != undefined) {
            setData(props.filterData)

        }
    }, [props.filterData])

    function _filtraFiltri(text: string) {
        setSearchText(text);
        props.actionFilters.getFilters(props.property, text)
        if (props.count.filter(x => x == props.property).length < 1) {
            props.actionFilters.updateCount(props.property)
        }
    }

    const _showAll = () => {
        props.actionFilters.getFilters(props.property, "")
        props.actionFilters.updateCount(props.property)
    }

    const handleChange = (id: string | undefined, event: any) => {
        const checked = event.target.checked
        let val;
        switch (id) {
            case "True":
                val = true
                break;

            default:
                val = false
                break;
        }
        id && props.actionFilters.getFiltriAttivi(val, checked, props.overrideProperty == "" ? props.property : props.overrideProperty)

        if (props.FiltriAttivi?.length === 0) {
            props.actionFilters.getFilters(props.property, searchText)
        }
    }

    const openClose = (show: boolean) => {
        if (show) {
            props.actionFilters.settingVisibility(props.property)
        } else {
            props.actionFilters.settingVisibility("")
        }
        setSearchText("")
        setShowList(show)
        if (show) {
            props.actionFilters.getFilters(props.property, "")
        }
    }


    return (
        <div className="relative">
            <div className="d-flex flex-row">
                <button type="button" className="filterSearch flex-row w-100 justify-content-center" onClick={() => openClose(true)} onBlur={() => !showListFixed ? props.actionFilters.settingVisibility("") : null}>
                    <img src={require(`../svg/chevron_${props.isVisibleFiltriString == props.property ? "up" : "down"}_Gray.svg`)}></img>
                </button>
                {props.FiltriAttivi && props.FiltriAttivi.length > 0 ?
                    <button type="button" className="btn btnTransaparent px-0 ml-2 mr-1" onClick={() => props.actionFilters.resetFilter(props.property)}>
                        <img src={require('../svg/close.svg')} height="13"></img>
                    </button>
                    : null}
            </div>
            {props.isVisibleFiltriString == props.property ?
                <div className="col-12 row mx-0 px-2 mt-2 filterMenu absolute" onMouseEnter={() => setShowListFixed(true)} onMouseLeave={() => delayClose(() => { setShowListFixed(false); visibilityAction() }, 500)}>
                    {data !== undefined && data !== null && data.length !== 0 ? data?.sort((a, b) => (a.text?.toLowerCase() > b.text?.toLowerCase()) ? 1 : -1).map((item, index) => {
                        const filtroAttivo = props.FiltriAttivi && props.FiltriAttivi.find(x => x == (item.value == "True" ? true : false)) != null ? true : false;
                        return (
                            item.text != "" && item.value != null ? <div className="w-100 d-flex flex-row align-items-center mx-0 mt-1" key={item.value + index}>
                                <input type="checkbox" className="filterCheckbox mr-2" defaultChecked={filtroAttivo} onChange={(e) => handleChange(item.value, e)} placeholder="Search..." id={item.value}></input>
                                <img height="20" className="mr-1" alt={rtnUrlStatusBooleanImg(item.value).label} title={rtnUrlStatusBooleanImg(item.value).label} src={rtnUrlStatusBooleanImg(item.value).img}></img>
                                <label htmlFor={item.value} className={`regular mb-0 ${rtnUrlStatusBooleanImg(item.value).label}`} style={{ display: "inline" }} dangerouslySetInnerHTML={{ __html: rtnUrlStatusBooleanImg(item.value).label }}></label>
                            </div> : null
                        )
                    })
                        : <label>NO VALUES</label>
                    }
                </div> : null}

        </div>
    )
}

export default FilterMenuIconBooleanCheckbox